import { render, staticRenderFns } from "./EmpresasList.vue?vue&type=template&id=667106d4&"
import script from "./EmpresasList.vue?vue&type=script&lang=js&"
export * from "./EmpresasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports